import get from 'lodash/get';
import size from 'lodash/size';

import * as helpers from './helpers';

const DEFAULT_OBJECT = {};
const DEFAULT_ARRAY = [];

export const selectTreePickerState = state => {
  return state.getIn(['chat', 'treePicker']);
};

export const getSelectedId = state => {
  return state.getIn(['chat', 'treePicker', 'selectedId'], '');
};

export const selectFormValues = state => {
  return state.getIn(['chat', 'entities', 'forms', 'formValues'], DEFAULT_OBJECT);
};

export const selectTree = (state, property) => {
  const formValues = selectFormValues(state);

  return get(formValues, [property], {});
};

export const selectCurrentTree = state => {
  return state.getIn(['chat', 'treePicker', 'tree'], DEFAULT_OBJECT);
};

export const selectBreadcrumbs = state => {
  return state.getIn(['chat', 'treePicker', 'selectedPath'], DEFAULT_ARRAY);
};

export const selectParent = state => {
  return state.getIn(['chat', 'treePicker', 'parent'], DEFAULT_OBJECT);
};

export const selectOnlyLeaf = state => {
  const treePickerState = selectTreePickerState(state);

  return treePickerState.get('lastNodeRequired', false);
};

export const selectIsBranch = (state, nodeId) => {
  const tree = selectCurrentTree(state);
  const node = helpers.findNode(tree, nodeId);

  if (!node.children) return false;

  return !!size(node.children);
};

export const selectCanSubmit = state => {
  const selectedId = getSelectedId(state);
  if (!selectedId) return false;

  const lastNodeRequired = selectOnlyLeaf(state);
  const isNodeABranch = selectIsBranch(state, selectedId);

  return !(lastNodeRequired && isNodeABranch);
};
